import * as React from 'react';
const { createContext, useContext, useMemo } = React;

import Grid from '../grid';
import {
	ViewProps,
	ExtraViewProps,
	ViewLayoutRoot,
	ViewRoot,
	ExtraViewRoot,
	FixedView,
} from './styled';


const ViewContext = createContext({
	layoutAppearance: 'default',
});

export type ViewLayoutProps = {
	appearance?: 'default' | 'nested-routes';
}

const ViewLayout: React.SFC<ViewLayoutProps> = ({ appearance, children }) => {
	const minHeight = appearance === 'nested-routes'
		?	'calc(100vh - 126px)'
		: 'calc(100vh - 70px)';
	const contextValue = useMemo(() => ({ layoutAppearance: appearance }), []);

	return (
		<ViewContext.Provider value={contextValue}>
			<ViewLayoutRoot>
				<Grid.Container minHeight={minHeight} stretch>
					{children}
				</Grid.Container>
			</ViewLayoutRoot>
		</ViewContext.Provider>
	);
}

ViewLayout.defaultProps = {
	appearance: 'default',
};

const View: React.SFC<ViewProps> = props => {
	const {
		appearance,
		fullWidth,
		padding,
		autoHeight
	} = props;
	const { layoutAppearance } = useContext(ViewContext);

	return (
		<Grid.Column desktop={fullWidth ? 12 : 9} laptop={fullWidth ? 12 : 8}>
			<ViewRoot
				appearance={appearance}
				fullWidth={fullWidth}
				padding={padding}
				autoHeight={autoHeight}
				layoutAppearance={layoutAppearance}>
				{props.children}
			</ViewRoot>
		</Grid.Column>
	);
}

View.defaultProps = {
	appearance: 'paper',
	padding: '32px 40px 40px 40px'
};

const ExtraView: React.SFC<ExtraViewProps> = ({ fullWidth, padding, children }) => {
	return (
		<Grid.Column desktop={3} laptop={4}>
			<ExtraViewRoot fullWidth={fullWidth} padding={padding}>
				{children}
			</ExtraViewRoot>
		</Grid.Column>
	);
}

const PageView = {
	Layout: ViewLayout,
	Content: View,
	Extra: ExtraView,
	Fixed: FixedView,
};

export default PageView;
